import React,{useState,useEffect} from 'react';
import { Link,useLocation } from 'react-router-dom';
import { ArrowRightOutlined } from '@ant-design/icons';
import moment from 'moment';
import * as Styled from './style.js';
import {getData } from '../../config/api-connect';
import {  Table, Select, Spin ,Skeleton} from 'antd';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer} from 'recharts';
import Spinner from '../../components/spinner'

const LeadsGenerated = ({ leadsGeneratedRef, month, year,cities,venues,venueId }) => {
    const location = useLocation();
    const [graphData,setGraphData] = useState([])
    const [loading, setLoading] = useState(true)
    const [pageLoading, setPageLoading] = useState(true)
    const [leadSummary, setLeadSummary] = useState([])
    const [header, setHeader] = useState([])

    useEffect(()=>{
      getVenue()
      if(cities !== ''){
        getLeadsGenerated()
      }
    },[cities,venueId,month,year])

    const lead_columns = header.filter(col => col !== 'venue_id').map(col => ({
        title: col.charAt(0).toUpperCase() + col.slice(1).replace(/_/g, ' '),
        dataIndex: col,
        key: col,
        sorter: col === 'total' ? (a, b) => a.total - b.total : false,
        align: col !== 'venue' && 'center',
        render: col === 'venue' ? 
        (text, record) => {
            var date = year + '-' + month + '-01';
            const venuename = text.length > 35 ? `${text.slice(0, 35)}...` : text;
            return(
            <Link to={`/leadDetails/?venue_id=${record.venue_id}&report_no=76379&date=${date}`} className='venueTitle'>
                {venuename}
            </Link>
            )
        }
        : 
        text => text
    }))
    .concat([
        {
        title: '',
        dataIndex: 'venue_id',
        key: 'action',
        render: (value) => {
            var date = year + '-' + month + '-01';
            return(
            <Link to={`/leadDetails/?venue_id=${value}&report_no=76379&date=${date}`} className="venueTitle">
                <ArrowRightOutlined />
            </Link>
            )
        },
        align: 'center'
        }
    ]);

    const getGraphData = async (venue,cities) => {
      setLoading(true)
      await getData(`/business/get_leads_graph/?venue_id=${venue}&city_id=${cities}&month=${month}&year=${year}&lead_type=leads_generated`)
      .then(response =>{
        setGraphData(response.result)
      })
      .catch(error => {
        console.log(error.message);
      })
      .finally(()=>{
        setLoading(false)
      })
    }

    const getVenue = async() => {
      let choosenVenue = 'All'
      let choosenCity = 'All'
      if(venueId) {
        choosenVenue = venueId
      }
      if(cities) {
        choosenCity = cities.join(',')
      }
      getGraphData(choosenVenue,choosenCity)
    }

    const getLeadsGenerated = async () => {
      setPageLoading(true)
      var venue = get_venue_ids_for_report_api()
      var date = year + '-' + month + '-01'
      await getData(`/eagleeye/getTableDataJSON/?report_id=750760&date=${date}&venue_id=${venue}`)
      .then(response =>{
        setLeadSummary(response.data)
        setHeader(response.headers)
        setPageLoading(false)
      })
      .catch(error => {
        setPageLoading(false)
      });
    }

    const get_venue_ids_for_report_api = () =>{
      var venue = ''
      if(venueId == 'All'){
        if(cities){
          var venue = cities
          if(cities.length > 1){
            const venue_in_city = venues.filter(item => cities.includes(item.city));
            const locationIds = venue_in_city.map(v => v.location);
            var venue = locationIds.join(',');
          }
        }
      }
      else{
        var venue = venueId
      }

      if(venue == 'All'){
        var venue = 0
      }

      return venue;
    }

    return (
      <div ref={leadsGeneratedRef}>
        <Styled.Header>          
            <span>Lead Conversion - {moment(month, 'MM').format('MMMM') + ' ' + year}</span>
        </Styled.Header>

        <Styled.GraphContainer>
        <Styled.GraphDiv>
          <Styled.GraphDivLabelDiv>
            <Styled.LabelHeading> Leads Generated - Analysis </Styled.LabelHeading>          
          </Styled.GraphDivLabelDiv>

          {loading ?
            <div style={{ height: '28vh',display: 'flex',alignItems: 'center',justifyContent: 'center' }}>
              <Spin />
            </div>
          : graphData && graphData.length > 0 &&
            <ResponsiveContainer width="100%" height="80%">
              <LineChart width={400} height={400} data={graphData} margin={{top: 5,right: 10,left: 5,bottom: 5}}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis 
                    dataKey="month" 
                    tickFormatter={(value) => moment(value, "MMMM YYYY").format("MMM")}
                  />
                  <YAxis/>
                  <Tooltip  />
                  <Legend />
                  <Line type="monotone" dataKey="count" stroke="rgb(30 124 10)" name="Leads Generated"/>  
                </LineChart>
              </ResponsiveContainer>
            }
          </Styled.GraphDiv>
        </Styled.GraphContainer>
        {
          pageLoading ?
            <Skeleton active paragraph={{ rows: 7 }} title={false} />
          :  
          <Table
              className="ant-table-thead table_container"
              rowKey="id"
              columns={lead_columns}
              dataSource={leadSummary.map((row, index) => ({
              ...row,
              key: index,  
              }))}
              pagination={false}
              summary={() => {
                const totalRow = {};
                const excludeKeys = ['venue', 'venue_id'];
                const totalCount = leadSummary.length;
                let contains_slash = false
                if (totalCount > 0) {
                  Object.keys(leadSummary[0]).forEach((key) => {
                    if (!excludeKeys.includes(key)) {
                      if (leadSummary[0][key]) {
                        let totalA = 0;
                        let totalB = 0;
                        leadSummary.forEach((item) => {
                          const value = item[key];
                          if (typeof value === "string" && value.includes("/")) {
                            contains_slash = true
                            const [a, b] = value.split("/").map(Number);
                            totalA += isNaN(a) ? 0 : a;
                            totalB += isNaN(b) ? 0 : b;
                          } else {
                            contains_slash = false
                            const num = Number(value);
                            totalA += isNaN(num) ? 0 : num;
                          }
                        });
                        totalRow[key] = contains_slash ? `${totalA}/${totalB}` : `${totalA}`;
                      }
                    }
                  });
                } else {
                  return null;
                }
                return (
                  <Table.Summary.Row>
                    {lead_columns.map((col, index) => {
                      const key = col.dataIndex;

                      if (index === 0) {
                        return (
                          <Table.Summary.Cell key={key}><b>Total</b></Table.Summary.Cell>
                        );
                      }

                      if (key === 'venue_id') {
                        return <Table.Summary.Cell key={key} />;
                      }

                      return (
                        <Table.Summary.Cell key={key} align="center">
                          {totalRow.hasOwnProperty(key) ? (
                            <b>{totalRow[key]}</b>
                          ) : ''}
                        </Table.Summary.Cell>
                      );
                    })}
                  </Table.Summary.Row>
                );
              }}
          />
        }
      </div>
    );
};

export default LeadsGenerated;